export default () => {
  window.localStorage.removeItem('token');
  window.localStorage.removeItem('sex');
  window.localStorage.removeItem('userId');
  window.localStorage.removeItem('userEmail');

  let domain = document.location.host.replace('app.', '');
  domain = domain.replace('dev.', '');
  domain = domain.replace('stage.', '');
  domain = domain.replace('stage-vege.', '');

  if (!domain.startsWith('.')) {
    domain = `.${domain}`;
  }

  document.cookie = `Authentication=; domain=${domain}; path=/; max-age=${
    60 * 60 * 24 * 365 * -1
  }; secure`;
};
